import { useMemo } from "react";

import { CheckboxDropdownItem, Dropdown } from "@similarweb/ui-components";

import { useTranslation } from "pro-features/components/WithTranslation";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import crmEnrichmentFiltersService from "app/pages/sales-intelligence/modules/crm-enrichment/services/filters";

import { StyledDropdownButton } from "./styles";

type Props = {
    appendTo: string;
    pickListItemsOptions: readonly string[];
    selectedMultiValues: Record<string, boolean>;
    onMultiFilterValueSelect: (value: string) => void;
};

const FilterValueDropdown = ({
    appendTo,
    pickListItemsOptions,
    selectedMultiValues,
    onMultiFilterValueSelect,
}: Props) => {
    const translate = useTranslation();

    const selectedMultiValuesText = useMemo(() => {
        const selectedMultiValuesLabels = crmEnrichmentFiltersService.getSelectedMultiValuesLabels(selectedMultiValues);

        return crmEnrichmentFiltersService.getSelectedMultiValuesText(selectedMultiValuesLabels);
    }, [selectedMultiValues]);

    const hasSelectedValue = selectedMultiValuesText.length > 0;

    return (
        <Dropdown
            appendTo={appendTo}
            dropdownPopupHeight={232}
            selectedIds={selectedMultiValues}
            hasSearch
            searchPlaceHolder={translate("si.crm-enrichment.job-wizard.filters.value.search-placeholder")}
            onClick={({ children }: { children: string }) => onMultiFilterValueSelect(children)}
        >
            {[
                <StyledDropdownButton
                    key="dd-btn"
                    hasSelectedValue={hasSelectedValue}
                >
                    {hasSelectedValue ? (
                        selectedMultiValuesText
                    ) : (
                        <I18n translatable={{ key: "si.crm-enrichment.job-wizard.filters.value.dd.placeholder" }} />
                    )}
                </StyledDropdownButton>,
                ...pickListItemsOptions.map((option) => (
                    <CheckboxDropdownItem
                        key={option}
                        id={option}
                        selected={selectedMultiValues[option]}
                    >
                        {option}
                    </CheckboxDropdownItem>
                )),
            ]}
        </Dropdown>
    );
};

export default FilterValueDropdown;
